import React, { useEffect } from 'react';
import useZxingScanner from './hooks/useZxingScanner';

const QuickScanModal = ({ onResult, onClose }) => {
  const handleResult = (text) => {
    onResult(text);
    onClose();
  };

  const handleError = (msg) => {
    alert(msg);
    onClose();
  };

  const { videoRef, isReady } = useZxingScanner({
    active: true,
    onResult: handleResult,
    onError: handleError,
  });

  // Lock body scroll while modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.92)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
    }}>

      {/* Header */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0,
        padding: '16px 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <span style={{
          color: '#fff', fontFamily: 'DM Sans, sans-serif',
          fontSize: '14px', fontWeight: 600, letterSpacing: '0.08em',
          textTransform: 'uppercase', opacity: 0.9,
        }}>
          📷 QuickScan
        </span>
        <button
          onClick={onClose}
          style={{
            background: 'rgba(255,255,255,0.12)', border: 'none',
            color: '#fff', borderRadius: '8px',
            padding: '8px 16px', cursor: 'pointer',
            fontFamily: 'DM Sans, sans-serif', fontSize: '13px',
          }}
        >
          ✕ Cancel
        </button>
      </div>

      {/* Video feed */}
      <div style={{ position: 'relative', width: '100%', maxWidth: '480px' }}>
        <video
          ref={videoRef}
          style={{
            width: '100%', display: 'block',
            borderRadius: '12px',
          }}
          muted
          playsInline
        />

        {/* Targeting reticle */}
        <div style={{
          position: 'absolute', inset: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          pointerEvents: 'none',
        }}>
          <div style={{
            width: '72%', height: '22%',
            border: '2px solid #d8262c',
            borderRadius: '8px',
            boxShadow: '0 0 0 2000px rgba(0,0,0,0.35)',
          }} />
        </div>
      </div>

      {/* Status line */}
      <div style={{
        marginTop: '24px', textAlign: 'center',
        fontFamily: 'DM Sans, sans-serif', fontSize: '13px',
        color: isReady ? '#4ade80' : '#facc15',
        letterSpacing: '0.05em',
      }}>
        {isReady ? '● Scanning — point at barcode' : '◌ Starting camera…'}
      </div>

    </div>
  );
};

export default QuickScanModal;
